
    /**
     * @description
     *  Nivel de detalle del logger (el orden es relevante). Los niveles
     *  especiales NONE y ALL permiten apagar o encender todos los niveles de
     *  logging respectivamente.
     */

export enum LoggingLevel {

    NONE,
    FATAL,
    ERROR,
    WARNING,
    INFORMATION,
    DEBUG,
    TRACE,
    ALL
}
